<template>
  <div class="pagebox">
    <!-- 导航栏 -->
    <van-nav-bar
      class="nav_bar"
      :title="$route.meta.title"
      left-arrow
      @click-left="backToLast"
      @click-right="toShoppingCart"
      id="reset"
    >
      <template #left>
        <img
          style="width: 18.44px; height: 16.35px"
          src="@/assets/home/white_back.png"
        />
      </template>
      <template #right>
        <img
          style="width: 24px; height: 24px"
          src="@/assets/home/shopping_cart.png"
        />
      </template>
    </van-nav-bar>
    <!-- <nav-bar :title="$route.meta.title"></nav-bar> -->
    <div class="top_bg">
      <div class="top_scroll">
        <van-swipe
          class="swipe_box"
          :loop="false"
          :width="84"
          :show-indicators="false"
        >
          <van-swipe-item
            class="swipe_item"
            v-for="(item, index) in foodList"
            :key="index"
          >
            <div
              class="food_bg"
              style="height: 100%;position:relative;"
              @click="selectFoodType(item, index)"
            >
              <img
                v-if="item.filePath != null"
                class="food_img"
                :src="getFilePath(item.filePath)"
                style="
									width: 40px;
									height: 40px;
									margin-top: 22px;
									margin-left: 22px;
								"
              />
              <img
                v-else
                class="food_img"
                src="@/assets/home/items/product-all-cate.png"
                style="
									width: 38px;
									height: 38px;
									margin-top: 24px;
									margin-left: 24px;
								"
              />
              <div
                class="food_text"
                style="
									color: #333333;
									font-size: 11px;
									text-align: center;
									margin-top: 9px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
								"
                :style="{
                  color: index == currentSelect ? '#3377ff' : '#333333',
                }"
              >
                {{ item.goodsName }}
              </div>
              <div
                v-if="index == currentSelect"
                style="position: absolute;bottom: 10px;left:28px;right:28px;height:2px;background-color:#3377ff;"
              ></div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div ref="container">
      <van-sticky :container="container">
        <refresh-options @doneRefresh="doneRefresh"></refresh-options>
      </van-sticky>

      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="init"
        >
          <div class="list_box">
            <div
              class="list_box_item"
              v-for="(item, index) in dataList"
              :key="index"
              @click="toDetail(item)"
            >
              <div class="list_box_img_box">
                <img
                  class="list_item_img"
                  style="width: vw(330); height: vw(282)"
                  :src="getFilePath(item.filePath)"
                />
                <!-- <top-tips
            class="top_tips"
            isShowPic="1"
            :money="item.canWin"
          ></top-tips> -->
              </div>
              <div class="list_box_content">
                {{ item.productName }}
              </div>
              <div class="bottom_box">
                <div class="list_box_price">
                  ¥ {{ showPriceComputed(item) }}
                  <span v-if="showMinPriceComputed(item)">起</span>
                </div>
                <top-tips
                  isShowLinear="1"
                  :money="
                    `${(item.minDealPrice - item.minDistributionPrice).toFixed(
                      2
                    )}` + ''
                  "
                ></top-tips>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="add-paycar" @click="toShoppingCart">
      <img src="../../../assets/add-car.png" alt="" />
    </div>
  </div>
</template>

<script>
import navBar from "@/components/nav-bar.vue";
import topTips from "@/new_views/home/components/topTips.vue";
import { getImgUrl } from "@/mixins/getImgUrl";
import refreshOptions from "@/components/refresh-options.vue";
export default {
  data() {
    return {
      container: null,
      foodList: [],
      currentSelect: 0,
      dataList: [],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
      goodsType: "", //类别
      requestParams: {
        cityId: "",
        desOrKeyWord: "",
        districtId: "",
        endPrice: "",
        goodsTags: "",
        goodsType: "",
        originType: "1",
        preferentialPromotion: "",
        provinceId: "",
        sendCity: "",
        startPrice: "",
        sortFiled: "", //排序字段 0 热度  1最赚  2价格
        sortType: "", //0-DESC 降序，1-ASC升序
        recommendFlag: "0", //是否推荐(0：否；1：是)
      },
    };
  },
  mixins: [getImgUrl],
  components: {
    navBar,
    topTips,
    refreshOptions,
  },
  computed: {
    showPriceComputed() {
      var that = this;
      return function(res) {
        return that.$store.getters.identityDeal
          ? res.minDealPrice
          : res.minDistributionPrice;
      };
    },
    showMinPriceComputed() {
      var that = this;
      return function(res) {
        return that.$store.getters.identityDeal
          ? res.minDealPrice != res.maxDealPrice
          : res.minDistributionPrice != res.maxDistributionPrice;
      };
    },
  },
  mounted() {
    this.container = this.$refs.container;
    // this.init();
    this.getGoodsCategoryList();
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/home/productDetail/localProductDetail",
        query: { ID: item.id },
      });
    },
    getGoodsCategoryList() {
      this.$API.z_product.getGoodsCategoryList().then((res) => {
        this.foodList = res.data;
        this.foodList.unshift({ filePath: null, goodsName: "全部" });
      });
    },
    init() {
      var page = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$API.z_product
        .listSubscribeGoods(this.requestParams, page)
        .then((res) => {
          this.finished = false;
          if (res.code == 200) {
            if (this.pageNum == 1) {
              this.dataList = res.data.list;
            } else {
              this.dataList = this.dataList.concat(res.data.list);
            }
            if (res.data.list.length < this.pageSize) {
              this.finished = true;
            }
          }
          this.pageNum = this.pageNum + 1;
          this.refreshing = false;
          this.loading = false;
        });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNum = 1;
      this.init();
    },
    //菜单选择刷新
    doneRefresh(item) {
      this.requestParams.sortFiled = "";
      this.requestParams.sortType = "";
      this.requestParams.recommendFlag = "0";
      if (item.sortFiled === "all") {
      } else if (item.sortFiled === "recommendFlag") {
        this.requestParams.recommendFlag = "1";
      } else {
        this.requestParams.sortFiled = item.sortFiled;
        this.requestParams.sortType = item.showDESC;
      }
      this.onRefresh();
    },
    selectFoodType(item, index) {
      this.currentSelect = index;
      this.requestParams.goodsType =
        item.goodsName == "全部" ? "" : item.goodsName;
      this.onRefresh();
    },
    backToLast() {
      this.$router.go(-1);
    },
    toShoppingCart() {
      this.$router.push({ path: "/order/shippingCart" });
    },
  },
};
</script>

<style lang="scss" scoped>
.pagebox {
  background-color: #ffffff;
  height: 100%;
  .van-ellipsis {
    color: #ee0a24;
  }
  .nav_bar {
    width: 100%;
    position: absolute;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0);
  }
  ::v-deep .van-ellipsis {
    color: #ffffff;
  }

  // 去掉导航栏底部的一根细线
  .van-hairline--bottom:after {
    border-bottom-width: 0px;
  }
  .top_bg {
    position: relative;
    width: 100%;
    height: 203px;
    background: linear-gradient(to top, #ffffff, #4684ff, #3377ff);
    .top_scroll {
      position: absolute;
      bottom: vw(50);
      left: vw(30);
      right: vw(30);
      height: vw(220);
      border-radius: vw(20);
      background-color: #ffffff;
      box-shadow: 0 vw(6) vw(30) rgba(0, 0, 0, 0.04);
      .swipe_box {
        height: 100%;
        .food {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }
  .list_top_box {
    margin-left: vw(40);
    margin-top: vw(30);
    display: flex;
    flex-direction: row;
    align-items: center;
    .list_top_item {
      margin-right: vw(54);
      width: vw(70);
      height: vw(66);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .list_top_text {
        color: #333333;
        font-size: vw(28);
        text-align: center;
      }
    }
  }
  .list_box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    margin-top: vw(24);
    margin-left: vw(15);
    margin-right: vw(15);
    .list_box_item {
      margin-left: vw(15);
      margin-right: vw(15);
      margin-bottom: vw(10);
      width: vw(330);
      height: vw(444);
      .list_box_img_box {
        position: relative;
        .list_item_img {
          width: 100%;
          height: vw(282);
        }
        .top_tips {
          position: absolute;
          top: 0;
          left: 0;
          width: vw(160);
          height: vw(36);
        }
      }
      .list_box_content {
        margin-top: vw(10);
        max-height: vw(80);
        margin-left: vw(10);
        margin-right: vw(10);
        color: #333333;
        font-size: vw(28);

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -moz-box;
        -moz-line-clamp: 2;
        -moz-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
      }
      .bottom_box {
        margin-top: vw(10);
        display: flex;
        flex-direction: row;
        align-items: center;
        .list_box_price {
          margin-left: vw(10);
          margin-right: vw(10);
          // width: 100%;
          color: #ff1414;
          font-size: vw(28);
          span {
            color: #666666;
          }
        }
      }
    }
  }
  .add-paycar {
    box-sizing: border-box;
    width: 50px;
    height: 50px;
    position: fixed;
    bottom: 70px;
    right: 15px;
    background-image: linear-gradient(to right, #ff8433, #ff3530);
    border-radius: 25px;
    padding: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
